export const heroData = {
  title: "HR Software that brings you peace of mind.",
  subtitle: "Rated 5.0/5.0 by users",

  ctaPrimary: {
    text: "Get Started",
    url: "/book-demo",
  },

  ctaSecondary: {
    text: "Book Demo",
    url: "/book-demo",
  },

  reviews: {
    rating: 5,
    text: "Rated 5.0/5.0 by users",
    avatars: [
      "/assets/images/avatar1.webp",
      "/assets/images/avatar2.webp",
      "/assets/images/avatar3.webp",
      "/assets/images/avatar4.webp",
    ],
  },

  features: [
    "Amazing after-sales support",
    "Smart Employee Management",
    "Easy Attendance Tracking",
  ],
    trusted: {
    title: "Trusted by businesses",
    logos: [
      "/assets/logos/ms.svg",
      "/assets/logos/medical.svg",
      "/assets/logos/prof.svg",
      "/assets/logos/dolphin.svg",
      "/assets/logos/biostat.svg",
    ],
  },
};